import React, { useMemo } from 'react'

const MaPage = () => {
  const maDetail = useMemo(() => {
    let ma = {}
    try {
      ma = JSON.parse(localStorage.getItem('ma'))
      if (!ma) {
        window.location.replace('/login')
      }
    } catch (e) {
      window.location.replace('/login')
      console.log(e)
    }

    return ma
  }, [])

  const thDate = date => {
    return new Date(date).toLocaleDateString('th', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    })
  }

  return (
    <div className="MA-page">
      <style>
        {`
    body {
      font-family: 'Prompt', sans-serif;
      font-weight: normal;
      font-style: normal;

    }

    .MA-page {
      background-image: radial-gradient(white, #C8D7E2);
      height: 100vh;
      width: 100vw;
      margin: 0px;
      padding: 0px;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 99999;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }

    .img-custom {
      margin-bottom: 30px;

    }

    .logo-sourcing {
      width: 30em;
      height: fit-content;
    }

    .box-content {
      text-align: center;
      color: #1B517E;

    }

    h3 {
      font-size: 40px;
      margin-bottom: -10px;
      font-weight: normal;
    }

    h1 {
      font-size: 50px;
      margin-bottom: 40px;
      font-weight: normal;
    }

    p {
      font-size: 25px;
    }

    .logo-server {
      margin: 20px;
      position: absolute;
      bottom: 0;
      right: 0;
    }

    .logo-huawei {
      width: 50px;
    }
    `}
      </style>

      <div className="img-custom">
        <img
          src="/maintain-t-space-logo.svg"
          alt="tspace_sourcing"
          className="logo-sourcing"
        />
      </div>
      <div className="box-content">
        <h3>ขอแจ้งปิดเว็บไซต์</h3>
        <h1>เพื่อปรับปรุงระบบชั่วคราว</h1>
        <p>
          ในวันที่ {thDate(maDetail.maStart)} น.
          <br />
          ถึง วันที่ {thDate(maDetail.maStop)} น.
          <br />
          ขออภัยในความไม่สะดวก
        </p>
      </div>
    </div>
  )
}

export default ({ children }) => {
  let { pathname } = window.location
  if (pathname === '/ma' && pathname !== '/login') {
    return <MaPage />
  }

  return <>{children}</>
}
